import { render, staticRenderFns } from "./010interlude.vue?vue&type=template&id=96f133e0&scoped=true&"
import script from "./010interlude.vue?vue&type=script&lang=js&"
export * from "./010interlude.vue?vue&type=script&lang=js&"
import style0 from "./010interlude.vue?vue&type=style&index=0&id=96f133e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f133e0",
  null
  
)

export default component.exports